import type { App } from 'vue'
import { createHead } from '@vueuse/head'

/**
 * Head manager (@vueuse/head).
 *
 * Enables per-route <title>/<meta> management via `useHead()` in pages.
 * The static fallbacks live in index.html; this lets individual routes
 * (landing, static pages) override title/description/canonical/OG so search
 * engines and prerendered output get page-specific metadata.
 */
const head = createHead()

export function installHead(app: App): void {
  app.use(head)
}
